import { BCMBookingIdRemarkRuleListItem } from '../../../integrated-client/models';

export type RuleListItemsList = Array<BCMBookingIdRemarkRuleListItem>;
export class RemarksResultsData {

  ruleList: RuleListItemsList
  showMore: boolean

  constructor() {
    this.ruleList = [];
    this.showMore = false;
  }

}